module.exports = __webpack_public_path__ + "img/vuetify-name-dark.26882d0e.png";